import React from 'react';
import ProtectedRoutes from '../components/ProtectedRoutes/ProtectedRoutes';

const Routes = () => <ProtectedRoutes />;

export default Routes;
